<label class="switch switch--{{ type }} switch--size-{{ size }} {{ box ? 'switch--box-' + box : '' }} switch--border-radius--{{ borderRadius }}" [ngClass]="{ 'switch--box': box, 'switch--disabled': disabled }">
  @if (titleLeft) {
    <span class="switch__title" [ngClass]="{ 'switch__title--active': !active && type === 'default' }">{{ titleLeft }}</span>
  }
  <div class="switch__switcher">
    <input class="switch__input" type="checkbox" [attr.name]="name" [(ngModel)]="active" [disabled]="disabled" (change)="change()" (focus)="focus()" />
    <div class="switch__main">
      <span class="switch__check"></span>
    </div>
  </div>
  @if (titleRight) {
    <span class="switch__title" [ngClass]="{ 'switch__title--active': active && type === 'default' }">{{ titleRight }}</span>
  }
</label>
